import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: 'app-standard-drawing-dialog',
  templateUrl: './standard-drawing-dialog.component.html',
  styleUrls: ['./standard-drawing-dialog.component.css']
})
export class StandardDrawingDialogComponent implements OnInit {

  enableFilter = false;
  enableFullscreen = false;
  public Response: any[] = [];

  constructor(public _dialogRef: MatDialogRef<StandardDrawingDialogComponent>,@Inject(MAT_DIALOG_DATA) public data: any) 
    {
      if (this.data) 
      {
        this.Response=this.data;
      }
    }

  ngOnInit() {
  }

  getCodeColor(code: number) 
  {
      if(code == 200)
      {
        return '#33ae10';
      }
      else if(code == 205)
      {
        return '#FBC02D';
      }
      else if(code!=200 && code!=205)
      {
        return '#c57a7a';
      }
      else 
      return 
  }

  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }

  toggleFullscreen() {
    this.enableFullscreen = !this.enableFullscreen;
  }
  closeDialog() {
    this._dialogRef.close();
  }

}
